// @flow
export const ipadWithStoreLink = {
	messageIdsFirstPara : 'apps.downloadOnMobile.ipadWithStoreLink.para1',
	messageIdsSecondPara : 'apps.downloadOnMobile.ipadWithStoreLink.para2',
	emailMelink : 'apps.downloadOnMobile.ipadWithStoreLink.link'
};

export const genericEmailMeLink = {
	messageIdsFirstPara : 'apps.downloadOnMobile.genericEmailMeLink.para1',
	emailMelink : 'apps.downloadOnMobile.genericEmailMeLink.link'
};

export const chromeBookCompanionMobileApp = {
	messageIdsFirstPara : 'apps.downloadOnMobile.chromeBookCompanionMobileApp.para1'
};

export const chromeBookAlternateMobileApp = {
	messageIdsFirstPara : 'apps.downloadOnMobile.chromeBookAlternateMobileApp.para1'
};

export const chromeBookAlternateAppName = {
	illustrator : 'Adobe Illustrator Draw',
	acrobat : 'Adobe Acrobat Reader',
	premiere : 'Adobe Premiere Rush',
	photoshop : 'Adobe Photoshop Express'
};

const productsWithCompanionApp = ['lightroom', 'xd', 'rush', 'fresco-desktop'];

export function hasCompanionApp(productId: string) {
	return productsWithCompanionApp.includes(productId);
};